import { useMediaQuery } from '@mui/material';
import { IBudgetSummary } from '../../createAndEdit/types';
import DetailSummaryMobile from './mobile/DetailSummaryMobile';

interface IDetailSummaryProps {
  summary: IBudgetSummary;
  counterProposalAcceptedAt?: string | null;
  isMobile?: boolean;
  isManagerAndDoesntHavePlan?: boolean;
}

const DetailSummary = (props: IDetailSummaryProps) => {
  const isMobile = useMediaQuery('(max-width: 768px)');
  
  if (isMobile) {
    return (
      <DetailSummaryMobile
        summary={props.summary}
        counterProposalAcceptedAt={props.counterProposalAcceptedAt}
      />
    );
  }
  
  const formatCurrency = (value: number): string => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(value);
  };

  return (
    <div className="flex items-center justify-between border border-gray-300 rounded-md p-4 mt-80">
      {!props.isManagerAndDoesntHavePlan ? (
        <div className='flex items-center gap-5 bg-[#F5F8FB] p-5'>
          <span className='rioglyph rioglyph-info-sign text-[#4B80A699] text-3xl'></span>
          <p className='text-xl text-[#2A3740]'>Será emitido um boleto com o valor a ser pago</p>
        </div>
      ) : <div/>}
      <div className="flex flex-col">
        <div className="flex flex-row items-center justify-end gap-5 text-[#2A374099] pr-2 text-size-20 text-uppercase text-medium">
          <span>Subtotal:</span>
          <span>{formatCurrency((props.summary.subtotal ?? 0) + (props.summary.subscriptionTotalApproved ?? 0))}</span>
        </div>
        {/* <div className="flex flex-row items-center justify-end gap-5">
          <span className="text-green-600">Descontos:</span>
          <span className="font-bold text-green-600">{formatCurrency(props.summary.discounts)}</span>
        </div> */}
        {props.summary.subscriptionTotalApproved ? <div className="flex flex-row items-center justify-end gap-5">
          <span className="text-green-600">Valor aprovado plano de manutenção:</span>
          <span className="font-bold text-green-600">{formatCurrency(props.summary.subscriptionTotalApproved)}</span>
        </div> : null}
        {!props.isManagerAndDoesntHavePlan &&  props.summary.subscriptionBalanceApplied ? <div className="flex flex-row items-center justify-end gap-5 text-[#5CB85C] text-size-20 text-uppercase text-medium">
          <span>Saldo utilizado:</span>
          <span>{formatCurrency(props.summary.subscriptionBalanceApplied)}</span>
        </div> : null}
        <div className={`flex flex-row items-center justify-end gap-5 text-[#2A3740] pr-2 text-size-18 text-size-20 text-uppercase text-medium ${props.counterProposalAcceptedAt ? 'line-through' : ''}`}>
          <span>Valor a ser pago:</span>
          <span>{formatCurrency(props.summary.totalToPay)}</span>
        </div>
        {props.counterProposalAcceptedAt && (
          <div className="flex flex-row items-center justify-end gap-5">
            <span className="font-bold text-size-16">Valor a ser pago:</span>
            <span className="font-bold text-size-16">{formatCurrency(props.summary.counterProposalValue || 0)}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default DetailSummary;


